import React from 'react';
import {
  Fieldset,
  Field,
  FieldFeedback,
  Legend,
  Checkbox,
} from '@piggybank/form';
import { Translation } from 'srcAlias/client/locale';
import { get } from 'lodash-es';
import config from 'configAlias';
export const OtherEquityMarketCountries = () => {
  const { segments } = config;
  const customerSegment = segments.find((segment) => segment[0] === 'customer');
  const otherEquityMarketCountries = get(
    customerSegment,
    '[4].otherEquityMarketCountries'
  );
  return (
    <Fieldset marginBottom={5} name={'marketsAcceptPageCheckbox'}>
      <Legend>
        <Translation path="otherEquityMarketsCheckbox" />
      </Legend>
      {otherEquityMarketCountries.map((item, index) => (
        <Field
          key={index}
          marginBottom={0}
          name={`marketsAcceptPageCheckbox.${item}`}
        >
          <Checkbox>
            <Translation path={item} />
          </Checkbox>
        </Field>
      ))}
      <FieldFeedback />
    </Fieldset>
  );
};
